import { ActionIcon, Group, Text } from '@mantine/core';
import { IconSparkles, IconX } from '@tabler/icons-react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { MessageSkill } from '../chat/types';
import { skillLabel } from 'src/common/utils/skillNames';

type Props = {
  skill: MessageSkill;
  onRemove?: () => void;
};

/**
 * The skill a message will use (or used, in history), as a pill on the dark chat surface. In the
 * composer it sits at the start of the first line of text, so it is kept to the height of that
 * line; above a sent message it has room for its usual padding.
 */
export function SelectedSkillChip({ skill, onRemove }: Props) {
  const label = skillLabel(skill);
  return (
    <Group
      gap="xxxs"
      wrap="nowrap"
      w="fit-content"
      maw="100%"
      pl="sm"
      pr={onRemove ? 'xxxs' : 'sm'}
      py={onRemove ? undefined : 'xxxs'}
      style={{
        borderRadius: 'var(--mantine-radius-xl)',
        border: '1px solid var(--mantine-color-gray-7)',
        backgroundColor: '#1a1a1a',
      }}
    >
      <IconSparkles size={14} color="var(--mantine-color-orange-4)" />
      <Text size="xs" c="white" fw={FONT_WEIGHTS.medium} lineClamp={1}>
        {label}
      </Text>
      {onRemove && (
        <ActionIcon
          variant="subtle"
          color="gray"
          radius="xl"
          size="xs"
          aria-label={`Remove skill ${label}`}
          onClick={onRemove}
        >
          <IconX size={12} />
        </ActionIcon>
      )}
    </Group>
  );
}
